import { Link } from 'react-router'
import { Reveal, Section, SectionHeading, ShotFrame } from '@/components/primitives'
import { SignalDrilldown } from '@/components/visuals/SignalDrilldown'

const POINTS = [
  {
    title: 'Numbers open records',
    detail: 'Click a dashboard number. See the list. Open the person. Proof, not a dead chart.',
  },
  {
    title: 'Rules that actually run',
    detail: 'Routing, follow-ups, and approvals are versioned. Drafts don’t go live alone.',
  },
  {
    title: 'Conversations stay attached',
    detail: 'Calls, texts, and notes land on the same customer story your floor is working.',
  },
]

export function ConnectedProof() {
  return (
    <Section labelledBy="proof-heading">
      <Reveal>
        <SectionHeading
          id="proof-heading"
          title="See a number. Click it. Meet the person behind it."
          copy="Dashboards, workflows, and conversations share one customer story, so the operation is legible, not scattered."
        />
      </Reveal>

      <div className="mx-auto mt-12 max-w-5xl">
        <Reveal delay={60}>
          <ShotFrame
            src="/images/omni-map-1100w.webp"
            srcSet="/images/omni-map-768w.webp 768w, /images/omni-map-1100w.webp 1100w, /images/omni-map-1600w.webp 1600w"
            sizes="(min-width: 1024px) 56vw, 100vw"
            width={1100}
            height={631}
            alt="TLDNXS Omni map: field and territory view on the same customer records"
            tag="Real TLDNXS Omni · demo account"
            caption="Same records. Map view when the work is in the field."
          />
        </Reveal>
      </div>

      <Reveal delay={100}>
        <ul className="mx-auto mt-10 grid max-w-5xl gap-6 text-center sm:grid-cols-3">
          {POINTS.map((point) => (
            <li key={point.title} className="border-t border-signal/50 pt-4">
              <p className="text-sm font-bold text-ink">{point.title}</p>
              <p className="mt-1.5 text-sm leading-relaxed text-ink-mute">{point.detail}</p>
            </li>
          ))}
        </ul>
        <div className="mt-8 text-center">
          <Link to="/platform" className="btn-ghost px-0">
            Explore the full platform →
          </Link>
        </div>
      </Reveal>

      <Reveal delay={160}>
        <div className="mx-auto mt-12 max-w-3xl text-center">
          <p className="mono-label">How a number becomes a person</p>
          <div className="mt-4 text-left">
            <SignalDrilldown />
          </div>
        </div>
      </Reveal>
    </Section>
  )
}
